import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faShieldAlt,
    faCogs,
    faHandshake,
    faBalanceScale,
    faTasks,
    faChartLine,
    faFileInvoiceDollar
} from '@fortawesome/free-solid-svg-icons';
import AOS from 'aos';
import 'aos/dist/aos.css';

const services = [
    { icon: faFileInvoiceDollar, title: 'VAT/GST Services', description: 'Assistance with VAT/GST registration, return filing, and compliance.' },
    { icon: faBalanceScale, title: 'Corporate Tax', description: 'Comprehensive corporate tax planning, advisory, and compliance services.', color: 'text-success' },
    { icon: faHandshake, title: 'International Tax', description: 'Advisory on cross-border transactions, transfer pricing, and international tax treaties.', color: 'text-warning' },
    { icon: faTasks, title: 'Tax Audits & Disputes', description: 'Representing clients during tax audits and assisting with dispute resolution.', color: 'text-info' },
    { icon: faShieldAlt, title: 'Tax Risk Management', description: 'Identify and mitigate tax risks to ensure long-term compliance and stability.', color: 'text-danger' },
    { icon: faChartLine, title: 'Tax Planning', description: 'Strategic tax planning to optimize tax liabilities and enhance financial performance.' },
];

const reasons = [
    { title: 'Local and International Expertise', description: 'Our team possesses in-depth knowledge of local tax laws and international tax regulations.' },
    { title: 'Proactive & Strategic Approach', description: 'We don’t just handle compliance; we offer strategic advice to minimize your tax burden legally.' },
    { title: 'Tailored Solutions', description: 'Our tax services are customized to the specific needs of your business, regardless of its size or industry.' },
    { title: 'Trustworthy Partnership', description: 'We act as your trusted advisors, providing clear guidance and reliable support.' },
    { title: 'Confidentiality', description: 'All your financial and tax information is handled with the highest level of confidentiality.' },
    { title: 'Dedicated Support', description: 'You will have a dedicated team to assist you with all your tax-related queries and needs.' },
];

const TaxAgents = () => {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const sectionStyles = {
        padding: '80px 0',
        fontFamily: 'Segoe UI, sans-serif'
    };

    const leadStyle = {
        color: '#6c757d',
        fontSize: '1.25rem'
    };

    const cardBaseStyle = {
        borderRadius: '15px',
        transition: 'all 0.3s ease',
        height: '100%',
        cursor: 'pointer'
    };

    const handleMouseEnter = (e) => {
        e.currentTarget.style.backgroundColor = '#7f8986ff';
        e.currentTarget.style.color = '#fff';
        e.currentTarget.style.transform = 'translateY(-8px)';
        e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
    };

    const handleMouseLeave = (e) => {
        e.currentTarget.style.backgroundColor = '#fff';
        e.currentTarget.style.color = '#000';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
    };

    return (
        <>
            {/* Hero Section */}
            <section
                style={{
                    position: "relative",
                    height: "90vh",
                    backgroundImage: `url('./em3.png')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                <div style={{ background: "rgba(0,0,0,0.4)", padding: "20px", borderRadius: "10px" }}>
                    <p style={{ fontSize: "1.2rem" }}>Expert tax solutions for a complex world</p>
                    <h1 style={{ fontWeight: "bold", fontSize: "2.5rem" }}>Navigate tax landscapes with confidence and clarity</h1>

                    {/* WhatsApp Button */}
                    <a
                        href="https://wa.me/+971588124755"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="whatsapp-btn"
                    >
                        <i className="bi bi-whatsapp me-2"></i> Chat on WhatsApp
                    </a>
                </div>
            </section>

            <main>
                {/* Intro Section */}
                <section style={{ ...sectionStyles, backgroundColor: '#ffffffff' }}>
                    <Container>
                        <p style={leadStyle} data-aos="fade-up">
                            At <strong>Emkan</strong>, We understand that for many firms, interacting with the Federal Tax Authority (FTA) can be difficult and time-consuming.  In order to guarantee complete compliance with UAE tax laws, registered tax agents are essential in representing businesses before the FTA and managing submissions, clarifications, and correspondence.  Although Emkan is not a professional tax agent, we collaborate closely with reputable, FTA-approved tax agents to provide our clients with thorough and dependable tax assistance.

                            <details>
                                <summary>Read More</summary>
                                <p>
                                    
 By working together, we make sure that your company gets competent advice and skilled representation in all areas pertaining to tax compliance.  Since our partner tax agents are formally registered with the FTA, they can act on your behalf when it comes to submitting returns, handling audits, providing clarifications, and answering authority inquiries.

Our job at Emkan is to act as a liaison between your company and the tax agent.  Before submitting your records, we make sure they are correct and comprehensive by organizing, reviewing, and preparing them.  This guarantees a seamless, effective, and error-free process while the tax agent is representing you.  Together, we ensure that your business stays in compliance while avoiding fines or needless risks.

 From creating financial data and making sure that accounting records are accurate to working with our partner Tax Agents for official representation, we believe in offering end-to-end help.  In this manner, you gain both the official authority of a licensed tax agent and Emkan's financial competence.

By selecting Emkan, you may take advantage of our financial planning, strategic counsel, and continuous business support in addition to having access to a trustworthy network of tax experts that can represent you before the FTA.  Our partnership guarantees that you stay compliant, self-assured, and totally committed to the expansion of your company.
                                </p>
                            </details>
                        </p>
                    </Container>
                </section>

                {/* Services Section */}
                <section style={{ ...sectionStyles, backgroundColor: '#8496a8ff' }}>
                    <Container>
                        <h2 className="text-white fw-bold text-center mb-5" data-aos="fade-up">Our Tax Agent Services</h2>
                        <Row className="g-4">
                            {services.map((service, index) => (
                                <Col md={4} key={index} data-aos="zoom-in" data-aos-delay={index * 100}>
                                    <Card
                                        style={cardBaseStyle}
                                        className="p-4 text-center"
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <Card.Body>
                                            <FontAwesomeIcon
                                                icon={service.icon}
                                                className={`fs-1 mb-3 ${service.color || 'text-primary'}`}
                                            />
                                            <h5 className="fw-bold">{service.title}</h5>
                                            <p>{service.description}</p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>

                {/* Why Choose Us Section */}
                <section style={{ ...sectionStyles, backgroundColor: '#7d94a6ff' }}>
                    <Container>
                        <h2 className="text-white fw-bold text-center mb-5" data-aos="fade-up">Why Choose Emkan for Tax Agent Services?</h2>
                        <Row className="g-4">
                            {reasons.map((reason, index) => (
                                <Col md={4} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                    <Card
                                        style={cardBaseStyle}
                                        className="p-4"
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <Card.Body>
                                            <h5 className="fw-bold">{reason.title}</h5>
                                            <p>{reason.description}</p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>
            </main>
        </>
    );
};

export default TaxAgents;